<template>
  <v-dialog
    v-model="isOpen"
    max-width="500"
    persistent
  >
    <v-card
      rounded="lg"
      elevation="6"
    >
      <v-card-title class="text-h6 pb-2 d-flex align-center gap-2">
        <v-icon icon="mdi-delete-alert" color="error"></v-icon>
        Delete {{ entityName }}
      </v-card-title>

      <v-card-text>
        <div class="mb-4 pa-4 bg-error-lighten-5 rounded-lg border border-error-lighten-3">
          <div class="d-flex gap-2 mb-2">
            <v-icon icon="mdi-alert-circle" color="error" size="small"></v-icon>
            <p class="text-body2 text-error-darken-2 font-weight-bold mb-0">
              Warning: This action cannot be undone
            </p>
          </div>
          <p class="text-body2 text-error-darken-1 ml-6">
            Are you sure you want to permanently delete this {{ entityName.toLowerCase() }}?
          </p>
        </div>

        <div v-if="itemName" class="pa-4 bg-grey-lighten-4 rounded-lg">
          <p class="text-body2 text-grey-darken-2 mb-1">Item to be deleted:</p>
          <p class="text-body1 font-weight-bold mb-0">{{ itemName }}</p>
        </div>
      </v-card-text>

      <v-card-actions class="pt-0 gap-2">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          variant="tonal"
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          variant="tonal"
          @click="confirmDelete"
          prepend-icon="mdi-delete"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteConfirmationDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    entityName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      default: ''
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    confirmDelete() {
      this.$emit('confirm')
      this.isOpen = false
    },
    cancel() {
      this.isOpen = false
    }
  }
}
</script>
